<template>
    <div>
        <el-form label-position="left" label-width="120px" size="small" :model="form">
            <el-form-item class="w500" label="管理员名称"><el-input v-model="form.name"></el-input></el-form-item>
            <el-form-item class="w500" label="账号"><el-input v-model="form.account"></el-input></el-form-item>
            <el-form-item class="w500" label="密码"><el-input v-model="form.password" type="password"></el-input></el-form-item>
            <el-form-item class="w500" label="确认密码"><el-input v-model="form.password1" type="password"></el-input></el-form-item>
            <el-form-item class="w500" label="角色">
                <el-select v-model="form.group_id" placeholder="请选择">
                    <el-option v-for="(value, name) in groupList" :key="name" :label="value" :value="name"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="footer"><el-button type="primary" @click="formSubmit">提交</el-button></div>
    </div>
</template>
<script>
import { getAdminAuthGroupSelect, saveAdmin } from '@/api/auth';
export default {
    data() {
        return {
            form: {
                name: '',
                account: '',
                password: '',
                password1: '',
                group_id: ''
            },
            groupList: []
        };
    },

    async mounted() {
        const list = await getAdminAuthGroupSelect();
        this.groupList = list;
    },

    methods: {
        async formSubmit() {
            const { name, account, password, password1, group_id } = this.form;
            if (password !== password1) {
                return this.$notify({ title: '密码不一致', type: 'error' });
            }
            const params = {
                name,
                account,
                password,
                group_id
            };
            await saveAdmin(params);
            this.$notify({ title: '操作成功', type: 'success' });
            this.$router.push({ path: '/admin-list' });
        }
    }
};
</script>
<style lang="less" scoped>
.w500 {
    width: 500px;
}
.stage {
    border: 1px dashed #999;
    border-radius: 5px;
    width: 800px;
    padding: 10px;
    margin-top: 8px;
    position: relative;
    .delete {
        position: absolute;
        top: 10px;
        right: 10px;
    }
}
.stage-title {
    font-size: 23px;
    font-weight: 400;
    margin-top: 5px;
}
.stage-group,
.stage-tag {
    margin-top: 5px;
    font-size: 18px;
}
.empty {
    margin-left: 200px;
}
</style>
